import { render, staticRenderFns } from "./ExamGuideResult.vue?vue&type=template&id=af231daa"
import script from "./ExamGuideResult.vue?vue&type=script&lang=js"
export * from "./ExamGuideResult.vue?vue&type=script&lang=js"
import style0 from "./ExamGuideResult.vue?vue&type=style&index=0&id=af231daa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports